import Inputmask from "inputmask"

export class PbmLoginMask {
  constructor() {
    this.cpfElement = document.querySelector("#nroCpf");
    this.cepElement = document.querySelector("#nroCep");
    this.cartaoElement = document.querySelector("#nroCartao");
    this.init()
  }

  init() {
    Inputmask.extendDefaults({
      'autoUnmask': true
    });

    if(this.cpfElement)
        Inputmask("999.999.999-99").mask(this.cpfElement)
    if(this.cepElement)
        Inputmask("99999-999").mask(this.cepElement)
    if(this.cartaoElement)
        Inputmask("integer", { rightAlign: false }).mask(this.cartaoElement)
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-login/pbm-login.mask.js